import type { PumpStatus } from "@tandemdiabetes/sugarmate-api-react-client"
import dayjs from "dayjs"
import { useMemo } from "react"
import { useThisMinute } from "src/hooks/time"

/*
 * returns true if the sensor will expire within 24 hours or has already expired
 */
export function useIsPumpStatusSensorNearlyExpired(pumpStatus: PumpStatus): boolean {
  const { sensor_expiration: sensorExpiration } = pumpStatus
  const thisMinute = useThisMinute()

  return useMemo(
    () => {
      if (sensorExpiration === null) {
        return false
      }

      return dayjs(sensorExpiration).diff(
        thisMinute,
        "hours",
        true,
      ) <= 24
    },
    [
      sensorExpiration,
      thisMinute,
    ],
  )
}
